/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getConcernStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetConcernStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getConcernStatusByIdIdRegExpTwo)]).optional()
});

export type GetConcernStatusById = zod.input<typeof GetConcernStatusById>;
export type GetConcernStatusByIdOutput = zod.output<typeof GetConcernStatusById>;
